import { render, staticRenderFns } from "./AboutMain.vue?vue&type=template&id=020eb131&scoped=true"
import script from "./AboutMain.vue?vue&type=script&lang=js"
export * from "./AboutMain.vue?vue&type=script&lang=js"
import style0 from "./AboutMain.vue?vue&type=style&index=0&id=020eb131&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020eb131",
  null
  
)

export default component.exports